<template>
  <FormShell
    :title="$t('title')"
    show-back-btn
    :next-btn-text="$t('nextBtn')"
    :subtext="$t('subtext')"
  >
    <template #body>
      <ServiceFormStep :progress-value="progressValue" />
    </template>
  </FormShell>
</template>

<script>
import AbstractFormPage from 'chimera/all/components/page/AbstractFormPage'
import FormShell from '~/components/form/FormShell.PD-10913'
import ServiceFormStep from '~/components/form/steps/service/ServiceFormStep.PD-10913'
import VariantGuard from '~/middleware/VariantGuard.PD-10913'

export default {
  components: {
    FormShell,
    ServiceFormStep,
  },

  extends: AbstractFormPage,

  layout: 'variant.PD-10913',

  middleware: [VariantGuard], // PD-10913: shadows FlowGuard.

  /**
   * @returns {object}
   */
  data() {
    return {
      path: '/v2/offertes-aanvragen/type-opdracht',
      progressValue: 40,
      checkoutStep: 2,
    }
  },

  /**
   * Set translated head meta from i18n.
   */
  created() {
    this.headTitle = this.$t('headTitle')
    this.headDescription = this.$t('headDescription')
  },
}
</script>

<i18n>
{
  "nl-NL": {
    "headTitle": "Type opdracht",
    "headDescription": "Geef aan naar wat voor type makelaar je op zoek bent.",
    "title": "Type opdracht",
    "nextBtn": "Volgende",
    "subtext": "Gratis & volledig vrijblijvend"
  }
}
</i18n>
